import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

export default function PrivacyPolicy() {
  return (
    <main className="flex min-h-screen flex-col">
      <SEO 
        title="Privacy Policy | London Secondary Glazing Data Protection"
        description="Read our privacy policy to understand how London Secondary Glazing collects, uses, and protects your personal data. GDPR compliant data handling and customer privacy information."
        canonical="https://www.londonsecondaryglazing.co.uk/privacy-policy"
        keywords="privacy policy, data protection, GDPR, personal information, secondary glazing privacy"
      />
      <Navbar />
      <div className="container mx-auto px-4 py-16 flex-grow">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-primary">Privacy Policy</h1>
          <div className="prose max-w-none">
            <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
              <p>SecondaryGlazing.London ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we handle your personal information when you visit our website or use our services.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
              <p>We collect information that you provide directly to us, including:</p>
              <ul className="list-disc pl-6 mt-4">
                <li>Name and contact information</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Address details</li>
                <li>Information about your property and glazing requirements</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 mt-4">
                <li>Provide and improve our services</li>
                <li>Communicate with you about our services</li>
                <li>Send you quotes and process your requests</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
